export const EventCategories = [
    'Buttons',
    'Custom interactive components',
    'Forms',
    'Links',
    'Modals',
    'Navigation',
    'PDFs',
    'Videos',
    'Carousels',
    'Countries',
    'Languages',
    'Filters',
    'ActionResult',
    'Footer',
    'LiveChat',
    'Scroll state',
    'Page',
    'Section'
];
export var TrackType;
(function(TrackType) {
    TrackType[TrackType["PAGE"] = 0] = "PAGE";
    TrackType[TrackType["EVENT"] = 1] = "EVENT";
})(TrackType || (TrackType = {}));

//# sourceMappingURL=IProvider.js.map